// extracted by mini-css-extract-plugin
export default {"buttonsGroup":"ButtonsGroup_buttonsGroup__OFHQ1","button":"ButtonsGroup_button__GfCbB","decline":"ButtonsGroup_decline__9PUXd","wrapper":"ButtonsGroup_wrapper__9RM0l"};